import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SensorNormalization } from '../models/sensorNormalization'
import { SensorNormalizationStateType } from './state'
import axios from 'axios'

export interface SensorNormalizationActionsType {
  getSensorNormalizations(): Promise<void>
  getSensorNormalizationsBySensorId(sensorId: string): Promise<void>
  getSensorNormalizationsBySensorSettingId(sensorSettingId: string): Promise<void>
  getActiveSensorNormalizations(): Promise<void>
  postSensorNormalization(sensorNormalization: SensorNormalization): Promise<void>
  putSensorNormalization(sensorNormalization: SensorNormalization): Promise<void>
  deleteSensorNormalization(id: string): Promise<void>
  refreshNormalization(id: string): Promise<void>
}

export const SensorNormalizationActions = {
  async getSensorNormalizations(this: SensorNormalizationStateType) {
    try {
      this.sensorNormalizations = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorNormalization: SensorNormalization) => {
            this.sensorNormalizations.push(sensorNormalization)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorNormalizations', error)
    }
  },
  async getSensorNormalizationsBySensorId(this: SensorNormalizationStateType, sensorId: string) {
    try {
      this.sensorNormalizations = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations/sensor/${sensorId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorNormalization: SensorNormalization) => {
            this.sensorNormalizations.push(sensorNormalization)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorNormalizations by sensorId', error)
    }
  },
  async getSensorNormalizationsBySensorSettingId(this: SensorNormalizationStateType, sensorSettingId: string) {
    try {
      this.sensorNormalizations = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations/sensor-setting/${sensorSettingId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorNormalization: SensorNormalization) => {
            this.sensorNormalizations.push(sensorNormalization)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorNormalizations by sensorSettingId', error)
    }
  },
  async getActiveSensorNormalizations(this: SensorNormalizationStateType) {
    try {
      this.sensorNormalizations = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations/active`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorNormalization: SensorNormalization) => {
            this.sensorNormalizations.push(sensorNormalization)
          })
        }
      })
    } catch (error) {
      console.error('Error getting active SensorNormalizations', error)
    }
  },
  async postSensorNormalization(this: SensorNormalizationStateType, sensorNormalization: SensorNormalization) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations`
      const data = convertDatesToISO(sensorNormalization.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensorNormalizations.push(sensorNormalization)
        }
      })
    } catch (error) {
      console.error('Error posting SensorNormalization', error)
    }
  },
  async putSensorNormalization(this: SensorNormalizationStateType, sensorNormalization: SensorNormalization) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations`
      const data = convertDatesToISO(sensorNormalization.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensorNormalizations = this.sensorNormalizations.map(sn => (sn.id === sensorNormalization.id ? sensorNormalization : sn))
          }
        })
    } catch (error) {
      console.error('Error updating SensorNormalization', error)
    }
  },
  async deleteSensorNormalization(this: SensorNormalizationStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensorNormalizations = this.sensorNormalizations.filter(sn => sn.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SensorNormalization', error)
    }
  },
  async refreshNormalization(this: SensorNormalizationStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-normalizations/${id}/refresh`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar el estado refreshed en el store local
          // this.getSensorNormalizations()
        }
      })
    } catch (error) {
      console.error('Error refreshing SensorNormalization', error)
    }
  },
}
